import marketingInstance from './instance'

const fetchCoupons = (page = 0, size = 10, couponType = null, active = null, activeForShop = null) => {
  return marketingInstance.get(
		'/coupons'
		+ '?page=' + page
		+ '&size=' + size
		+ (couponType !== null ? '&couponType=' + couponType : '')
		+ (active !== null ? '&active=' + active : '')
		+ (activeForShop !== null ? '&activeForShop=' + activeForShop : '')
	)
}

export default fetchCoupons
